const defaultDay = {
  hours: [],
  open: true,
}

const defaultHours = {
  friday: defaultDay,
  monday: defaultDay,
  saturday: defaultDay,
  sunday: defaultDay,
  thursday: defaultDay,
  tuesday: defaultDay,
  wednesday: defaultDay,
}

export { defaultDay, defaultHours }
